import { Box } from '@material-ui/core';
import { ReactNode } from 'react';

import { Font } from '@/components/shared/components/Font';

interface FieldHintProps {
  children: ReactNode;
  color?: 'text.secondary' | 'error.main';
}

export const FieldHint = ({ children, color = 'text.secondary' }: FieldHintProps) => (
  <Box mt={'3px'} color={color}>
    <Font variant="caption" color="inherit">
      {children}
    </Font>
  </Box>
);
